import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'

// ui
import { Timeline, Icon, Empty } from 'antd'

// subcomponent
import ReportComponent from './report_component'
import FilterHeader from './list_reports_filter_header'

class ListReports extends Component {
    render() {
        const _reports = this.props.reports
        return (
            <div>
                <FilterHeader />
                <div className="ListReports">
                    <Timeline mode="alternate" style={{ width: '100%' }}>
                        {_reports.length > 0 ? (
                            _reports.map((report, index) => {
                                return (
                                    <Timeline.Item color="green">
                                        <ReportComponent
                                            report={report}
                                            key={index}
                                        />
                                    </Timeline.Item>
                                )
                            })
                        ) : (
                            <Empty
                                description={<span>Không có dữ liệu</span>}
                            ></Empty>
                        )}
                    </Timeline>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        reports: state.qbreport.history_reports,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListReports)
